import React, { useEffect, useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import DeleteIcon from "@material-ui/icons/Delete";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  AccordionDivision,
  Product,
  Quantity,
  CardHeader,
  ItemDivision,
} from "~/pages/Order/styles";
import edit from "~/assets/images/edit.svg";
import IconProduct from "~/components/layout/IconProduct";
import OrderEdit from "~/components/pages/Order/Edit";
import OrderEditOrder from "~/components/pages/OrderEdit/Edit";
import { analytics, logEvent }  from "~/services/firebaseConfig";

export default function Items({ desktop, editedOrder, setDisableButton }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const items = useSelector((state) => state.orderReducer.items);
  const orderEditReducer = useSelector(state => state.orderEditReducer);
  const isEdit = useSelector((state) => state.orderReducer.modalEditOpen);

  const [idOrder, setIdOrder] = useState(0);

  function deleteItem(item) {
    setDisableButton && setDisableButton(false);
    dispatch({ type: "DELETED_ITEM" });
    dispatch({ type: "DELETE_ITEM", item });
  }

  const CustomToggle = ({ item, id }) => {
    return (
      <img
        src={edit}
        style={{ cursor: "pointer" }}
        alt="Ícone para edição"
        onClick={() => {
          if (desktop || window.screen.width > 768) {
            dispatch({ type: "MODAL_EDIT", modalEdit: true });
            setIdOrder(id);
          } else {
            history.push("/editar-pedido-abastecimento?id=" + id);
          }
        }}
      />
    );
  };

  return (
    <>
      {isEdit ? (
        <>
          {
            editedOrder ? (
              <OrderEditOrder setDisableButton={setDisableButton} desktop={desktop} idOrder={idOrder} />
            ) : (
              <OrderEdit desktop={desktop} idOrder={idOrder} />
            )
          }
        </>
      ) : <></>}
      {
        editedOrder ? (
          <>
          {orderEditReducer.orders.map((item, index) => (
            <ItemDivision key={item.id}>
              <Accordion defaultActiveKey="0">
                <Card.Header style={CardHeader}>
                  Item - {index + 1}
                  <DeleteIcon onClick={() => deleteItem(item)} />
                </Card.Header>
                <Card>
                  <div>
                    <Card.Body style={{ padding: ".85rem !important" }}>
                      <AccordionDivision>
                        <div>
                          <Product>
                            <IconProduct
                              productName={item.name}
                              styles={{
                                p2: { margin: "0 .5rem .2rem 0", width: "15%" },
                                p5: { margin: "0 .5rem .2rem 0", width: "15%" },
                                p20: { margin: "0 .5rem .2rem 0", width: "10%" },
                                p45: { margin: "0 .5rem .2rem 0", width: "10%" },
                                p90: { margin: "0 .5rem .2rem 0", width: "10%" },
                                p13: { margin: "0 .5rem .2rem 0", width: "15%" }
                              }}
                            />
                            {item.name}
                          </Product>
                        </div>
                        <div
                          style={{ display: "flex" }}
                          onClick={() =>
                            logEvent(analytics, 'editar_produto')
                          }
                        >
                          <Quantity>Qtd: {item.quantity}</Quantity>
                          <CustomToggle
                            eventKey="0"
                            item={orderEditReducer.orderChoosed}
                            id={index + 1}
                          ></CustomToggle>
                        </div>
                      </AccordionDivision>
                    </Card.Body>
                  </div>
                </Card>
              </Accordion>
            </ItemDivision>
          ))}
        </>
        ) : (
          <>
            {items.map((item, index) => (
              <ItemDivision key={item.id}>
                <Accordion defaultActiveKey="0">
                  <Card.Header style={CardHeader}>
                    Item - {index + 1}
                    <DeleteIcon onClick={() => deleteItem(item)} />
                  </Card.Header>
                  <Card>
                    <div>
                      <Card.Body style={{ padding: ".85rem !important" }}>
                        <AccordionDivision>
                          <div>
                            <Product>
                              <IconProduct
                                productName={item.product.name}
                                styles={{
                                  p2: { margin: "0 .5rem .2rem 0", width: "15%" },
                                  p5: { margin: "0 .5rem .2rem 0", width: "15%" },
                                  p20: { margin: "0 .5rem .2rem 0", width: "10%" },
                                  p45: { margin: "0 .5rem .2rem 0", width: "10%" },
                                  p90: { margin: "0 .5rem .2rem 0", width: "10%" },
                                  p13: { margin: "0 .5rem .2rem 0", width: "15%" }
                                }}
                              />
                              {item.product.name}
                            </Product>
                          </div>
                          <div
                            style={{ display: "flex" }}
                            onClick={() =>
                              logEvent(analytics, 'editar_produto')
                            }
                          >
                            <Quantity>Qtd: {item.quantity}</Quantity>
                            <CustomToggle
                              eventKey="0"
                              item={item}
                              id={index + 1}
                            ></CustomToggle>
                          </div>
                        </AccordionDivision>
                      </Card.Body>
                    </div>
                  </Card>
                </Accordion>
              </ItemDivision>
            ))}
          </>
        )
      }
    </>
  );
}
